import { ApolloClient } from "@apollo/client"
import {
  ResourceFragment,
  ResourceFragmentDoc
} from "@pathwright/graphql-client/src/generated"

/**
 * Read the shared Resource entity for Cover first paint.
 * List views write Resource:${id}; the CoverPageResource query root is usually a cache miss.
 */
export function readCoverPageResourceSeed(
  client: ApolloClient<unknown>,
  resourceId: number
): ResourceFragment | null {
  if (!resourceId) return null

  try {
    const seed = client.cache.readFragment<ResourceFragment>({
      id: `Resource:${resourceId}`,
      fragment: ResourceFragmentDoc,
      fragmentName: "Resource",
      // Accept incomplete entities (Algolia/thin related cards) when present.
      returnPartialData: true
    })

    // With returnPartialData, a missing entity can yield {} instead of null.
    if (!seed?.id) return null
    return seed
  } catch {
    // Apollo throws when the entity is missing entirely (without partial data).
    return null
  }
}
